import { PaymentServices } from '@/services/PaymentService';
import { AltType } from '@/utils/const';
import { defineStore } from 'pinia';
export const useMainStore = defineStore('main', {
    state: () => ({
        altId: '',
        altType: AltType.LOCATION,
        currency: '',
        country: '',
        currencyDetails: {},
        stripeAccountConnected: undefined,
        stripeKeys: undefined,
        hasUnsavedChanges: false,
        isInternal: false,
        authorizeAccountConnected: undefined,
        defaultPaymentProvider: undefined,
        authorizeNetKeys: undefined,
        getPaymentIntegrationLoading: true,
        nmiAccountConnected: false,
        nmiKeys: undefined,
    }),
    // optional getters
    getters: {
    // currencySymbol: state => {
    //   if (state?.currency && state?.currencyDetails?.currency) {
    //     return (
    //       state?.currencyDetails?.currency[
    //         state.currency as keyof CurrencyDetails
    //       ]?.symbol || '$'
    //     )
    //   }
    //   return '$'
    // },
    },
    // optional actions
    actions: {
        async getCurrencyDetails() {
            try {
                const { data } = await PaymentServices.getCurrencyDetails();
                this.currencyDetails = data;
            }
            catch (error) {
                console.error(error);
            }
        },
        setAppInitData(payload) {
            this.altId = payload.altId;
            this.altType = payload.altType;
            this.currency = payload.currency;
            this.timezone = payload.timezone;
            this.getCurrencyDetails();
        },
        // async getStripeIntegration() {
        //   try {
        //     const { data } = await PaymentServices.getStripeIntegration(this.altId)
        //     this.stripeAccountConnected = !!data
        //     this.stripeKeys = data
        //   } catch (error) {
        //     console.info(error)
        //   }
        // },
        // async getAllIntegrations() {
        //   this.getPaymentIntegrationLoading = true
        //   try {
        //     const { data } = await PaymentServices.getAllIntegrations(this.altId)
        //     this.authorizeAccountConnected =
        //       !!data?.authorizeNet?.test?._id || !!data?.authorizeNet?.live?._id
        //     this.stripeAccountConnected =
        //       !!data?.stripe?.test?._id || !!data?.stripe?.live?._id
        //     this.nmiAccountConnected =
        //       !!data?.nmi?.test?._id || !!data?.nmi?.live?._id
        //     this.stripeKeys = data.stripe
        //     this.authorizeNetKeys = data.authorizeNet
        //     this.nmiKeys = data.nmi
        //     this.defaultPaymentProvider = data.defaultPaymentProvider
        //     this.getPaymentIntegrationLoading = false
        //   } catch (error) {
        //     this.getPaymentIntegrationLoading = false
        //   }
        // },
    },
});
